// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"26c99017","453":"96453769","732":"3b14ac7e","977":"dbc3484d"}[chunkId] + ".chunk.js";
};